<template>
  <div class="cooperaionPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/02/4814452218230564617.png"
        alt=""
      />
    </div>

    <div class="main-content">
      <h1 class="main-title" v-html="$t('cooperation.mainTitle')"></h1>
      <p class="txt" v-html="$t('cooperation.paragraphs.txt1')"></p>
      <div class="img-box image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5411577449100158900.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
      <p class="txt" v-html="$t('cooperation.paragraphs.txt1')"></p>
      <p class="txt" v-html="$t('cooperation.paragraphs.txt2')"></p>
      <p class="txt" v-html="$t('cooperation.paragraphs.txt3')"></p>
      <p class="txt" v-html="$t('cooperation.paragraphs.txt4')"></p>
      <p class="txt" v-html="$t('cooperation.paragraphs.txt5')"></p>
    </div>

    <div class="new-group-layout" @click="handleToast">
      <div class="new-group-layout-content flex-between">
        <div class="new-left-content">
          <h1>中國地區（香港澳門&大陸地區）合作詳情諮詢</h1>
          <p>China (Hong Kong, Macau & Mainland China) cooperation details c</p>
        </div>
        <div class="new-right-content"><i class="icon-file"></i></div>
      </div>
      <div class="new-icons flex-rowc">
        <i class="icon-facebook"></i>
        <i class="icon-ins"></i>
        <i class="icon-cart"></i>
        <i class="icon-youtube"></i>
        <i class="icon-tiktok"></i>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "CooperationPage",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleToast() {
      this.$message.warning({
        message: "即将开放",
        center: true,
        duration: 1500,
        offset: 80,
      });
    },
  },
};
</script>
  <style lang="less">
/deep/.el-message {
  z-index: 1000000000001 !important;
}
.cooperaionPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    height: 600px;
  }
  .main-title {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .txt {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .main-content {
    padding: 110px 310px 192px;
    box-sizing: border-box;
    color: #000000;
    .main-title {
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      margin-bottom: 60px;
    }
    .img-box {
      margin-bottom: 90px;
    }
    .txt {
      font-size: 24px;
      margin-bottom: 70px;
      line-height: 40px;
      .highlight {
        font-weight: bold;
      }
    }
  }

  .new-group-layout {
    margin-bottom: 400px;
    .new-group-layout-content {
      width: 1060px;
      height: 160px;
      background: #f9f9f9;
      margin: 0 auto 30px;
      cursor: pointer;
      padding: 0 87px 0 130px;
      box-sizing: border-box;
      .new-left-content {
        h1 {
          font-size: 30px;
          color: #555555;
          position: relative;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          &::before {
            position: absolute;
            display: inline-block;
            content: "";
            width: 10px;
            height: 30px;
            background: #555555;
            top: 50%;
            transform: translateY(-50%);
            left: -20px;
          }
        }
        p {
          font-size: 18px;
          color: #9a9a9a;
          margin-top: 14px;
        }
      }
      .new-right-content {
        i {
          width: 15px;
          height: 18px;
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4904212986200255044.png);
          background-size: cover;
          display: inline-block;
        }
      }
    }
    .new-icons {
      width: 650px;
      border-top: 1px solid #000000;
      padding-top: 20px;
      margin: auto;
      i {
        display: inline-block;
        cursor: pointer;
        width: 29px;
        height: 29px;
        margin-right: 20px;
      }
      .icon-facebook {
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/5098712633813512321.png);
        background-size: cover;
      }
      .icon-ins {
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4853436759718255243.png);
        background-size: cover;
      }
      .icon-cart {
        width: 34px;
        height: 30px;
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4705043591895584161.png);
        background-size: cover;
      }
      .icon-youtube {
        width: 74px;
        height: 29px;
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4698212167918887025.png);
        background-size: cover;
      }
      .icon-tiktok {
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4973589452167469416.png);
        background-size: cover;
        margin-right: 0;
      }
    }
  }
}
</style>